// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/global.js
// module id = 3
// module chunks = 0